import { gql } from "@apollo/client"
import SESSION_FRAGMENT from "./session"

const EVENT_FRAGMENT = gql`
  ${SESSION_FRAGMENT}

  fragment EventFragment on Event {
    id
    title
    description
    start_date
    end_date
    event_setup_completed
    max_bookings_per_student
    disable_parent_bookings
    vc_auto_disconnect
    open_parents
    open_staff
    client_id
    created_at

    user {
      id
      name
      email
    }
    
    meetingTypes {
      id
      name
      type
    }

    sessions {
      ...SessionFields

      groups {
        id
        title
        user_id
      }
    }
  }
`

export default EVENT_FRAGMENT